import { MDCRipple } from "@material/ripple";
import { GravyBinder } from "gravy-bind";
import { AgentProfile } from "./models/agent/AgentProfile";
import { loopThroughElements } from "./utils/loop-through-elements";
declare var window: any;

export class MyAgentOverlay {
    public static cssClass: string = 'my-agent-overlay';
    private binder: GravyBinder;
    public agent: AgentProfile;
    private _expanded: boolean = false;
    public get expanded(): boolean {
        return this._expanded;
    }
    public set expanded(value: boolean) {
        this._expanded = value;
        this.binder.updateOutwardBindings();
    }

    constructor(private rootElement: HTMLDivElement) {
        if (window.disableAgentOverlay === true) {
            this.rootElement.remove();
        } else {
            this.binder = new GravyBinder(this, this.rootElement);
            this.extendBinder();
            this.registerEvents();
            this.load();
            this.initializeRipples();
        }
    }

    private load = async (): Promise<void> => {
        const response = await fetch('/api/myagent');
        const responseContent = await response.json();

        if (responseContent) {
            this.agent = AgentProfile.fromJs(responseContent);
            this.binder.updateOutwardBindings();
        }
    }

    private extendBinder = (): void => {
        this.binder.registerOutwardBinding('src', (element, value) => element.src = value);
        this.binder.registerOutwardBinding('alt', (element, value) => element.alt = value);
    }

    private registerEvents = (): void => {
        loopThroughElements(this.rootElement.getElementsByClassName('mdc-fab'), el => {
            el.addEventListener('click', () => this.expanded = true);
        });
        loopThroughElements(this.rootElement.getElementsByClassName('my-agent-overlay__close'), el => {
            el.addEventListener('click', () => this.expanded = false);
        });
    }

    private initializeRipples = (): void => {
        const fabRipple = new MDCRipple(this.rootElement.getElementsByClassName('mdc-fab')[0]);
        const iconRipple = new MDCRipple(this.rootElement.getElementsByClassName('mdc-icon-button')[0]);
        iconRipple.unbounded = true;
    }
}